var ContinueStatement = {
  print: function print() {
    return 'continue;';
  }
};
module.exports = ContinueStatement;